import PriceInfo from './price-info';

export default PriceInfo;
